// extracted by mini-css-extract-plugin
module.exports = {"main-component":"custSat_main-component__vysiW"};